module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Maegenwil_AG-a8aa432a9034c687391e0f9dc5e6c37e.svg";